import React, { useState } from "react";
import { Layout, Menu, Divider } from "antd";
import { useNavigate } from "react-router-dom";

const { Sider } = Layout;

const CommonSidebar = ({ defaultSelectedKey = "1" }) => {
  const [selectedKey, setSelectedKey] = useState(defaultSelectedKey);
  const navigate = useNavigate();

  const menuItems = [
    { key: "1", label: "Who We Are", path: "/about-us" },
    { key: "2",  label: "Problems We Are Solving", path: "/problem-we-are-solving" },
    { key: "3",  label: "Focus Areas", path: "/focus-areas-age" },
    { key: "4",  label: "Goals & Objectives", path: "/goals-objectives" },
    { key: "5", label: "Our Impact", path: "/our-impact" },
    { key: "6",  label: "Partnerships", path: "/partnerships" },
  ];

  const handleMenuClick = (e) => {
    setSelectedKey(e.key);
    const selectedItem = menuItems.find((item) => item.key === e.key);
    if (selectedItem?.path) {
      navigate(selectedItem.path);
    }
  };

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      width={450}
      style={{
       margin:"20px",
       marginLeft:'50px',
        background: "#f0f2f5",
        paddingTop: "40px",
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        onClick={handleMenuClick}
        style={{
          fontSize: "16px",
          background: "#f0f2f5",
          borderRight: "none",
        }}
      >
        {menuItems.map((item, index) => (
          <React.Fragment key={item.key}>
            <Menu.Item
              key={item.key}
              icon={item.icon}
              style={{
                margin: "20px 0",
                borderRadius: "8px",
                fontWeight: selectedKey === item.key ? "bold" : "normal",
                color: selectedKey === item.key ? "#000" : "#555",
                background:
                  selectedKey === item.key ? "transparent" : "transparent",
                transition: "all 0.3s ease",
              }}
            >
              {item.label}
            </Menu.Item>

            {index < menuItems.length - 1 && (
              <Divider style={{ margin: "4px 0", borderColor: "#d9d9d9" }} />
            )}
          </React.Fragment>
        ))}
      </Menu>
    </Sider>
  );
};

export default CommonSidebar;
